import script from "./graph-language-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./graph-language-select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__